// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"094f82f9","591":"2c0183c8","821":"fd6f9f07","860":"e630d904"}[chunkId] + ".chunk.js";
};